// Rails entry point: `react_component 'AlarmDeviceLegend'`, mounted once per tab.
//
// The implementation lives in LegendModalView.tsx (NOT named after the
// directory): webpack's `require.context` treats a sibling file named after its
// parent directory as a self-import, producing an undefined export at runtime.
import React from 'react';
import { LegendModalView } from './LegendModalView';
export default function Index() {
    return React.createElement(LegendModalView, null);
}
